import script from "./SectionEditModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./SectionEditModal.vue?vue&type=script&setup=true&lang=ts"

import "./SectionEditModal.vue?vue&type=style&index=0&id=3e343838&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e343838"]])

export default __exports__